import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import './FloatingWhatsApp.css';

const WA_LINK = 'https://wa.me/918605246832?text=Hi%2C%20I%20want%20to%20start%20my%20business%20with%20RRP%20%26%20Associates';

export default function FloatingWhatsApp() {
  return (
    <motion.a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-wa"
      aria-label="Chat on WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, type: 'spring', stiffness: 300, damping: 20 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      {/* Ripple rings */}
      <span className="floating-wa__ring floating-wa__ring--1" />
      <span className="floating-wa__ring floating-wa__ring--2" />
      <FaWhatsapp className="floating-wa__icon" />
      <span className="floating-wa__tooltip">Chat on WhatsApp</span>
    </motion.a>
  );
}
